'use client'

import Link from 'next/link'
import { ComputerDesktopIcon } from '@heroicons/react/24/outline'
import { useTranslations } from 'next-intl'

/**
 * Shown by the phone-width shell (ConditionalLayout) when the user lands on a
 * route that isn't part of the mobile experience — e.g. a deep link from an
 * email. Points them to the desktop for the full experience and back to the
 * dashboard on mobile.
 */
export default function MobileUnavailableNotice() {
  const t = useTranslations('shared.mobileUnavailable')

  return (
    <div className="flex flex-col items-center justify-center text-center px-6 py-20 gap-4">
      <div
        className="flex items-center justify-center w-14 h-14 rounded-2xl"
        style={{ background: 'var(--color-lime-muted)' }}
      >
        <ComputerDesktopIcon className="w-7 h-7" style={{ color: 'var(--color-lime)' }} />
      </div>
      <h1 className="text-xl font-semibold" style={{ color: 'var(--color-text-primary)' }}>
        {t('title')}
      </h1>
      <p className="text-sm max-w-xs" style={{ color: 'var(--color-text-secondary)' }}>
        {t('body')}
      </p>
      <Link
        href="/dashboard"
        className="mt-2 px-5 py-2.5 rounded-lg text-sm font-semibold transition-opacity hover:opacity-90"
        style={{ background: 'var(--color-lime)', color: 'var(--color-background)' }}
      >
        {t('goToDashboard')}
      </Link>
    </div>
  )
}
